export const BLOCK_SIZE = 35;
export const GROW_SIZE = 4;